module.exports = __webpack_public_path__ + "img/sdg_en_(6).a49d0cb2.png";